export default function AnimatedEllipsis() {
  return (
    <>
      <span className="typing-dot">&#9679;</span>
      <span className="typing-dot">&#9679;</span>
      <span className="typing-dot">&#9679;</span>
    </>
  )
}
